import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  key: string = "z!1458Opljds8#u&";
  appProperties = {
    VALUES: {
      KEY: "MTIz25U2Nzg5MEFCQ0RFRkdISUpLTE1Z",
      IV: "MFOzN0U2Nzg=Only"
    }
  };
  constructor() { }
  encryptionAES (msg:any) {
    // Encrypt
    const ciphertext = CryptoTS.AES.encrypt(msg, 'JapanDirect25#');
    return encodeURIComponent(ciphertext.toString());
  }

  decryptionAES (msg:any) {
    // Decrypt
    msg  = decodeURIComponent(msg);
    const bytes  = CryptoTS.AES.decrypt(msg, 'JapanDirect25#');
    const plaintext = bytes.toString(CryptoTS.enc.Utf8);
    return plaintext;
  }

  encryptUsingAES256(msg:any) { console.log(msg);
    let _key = CryptoTS.enc.Utf8.parse(this.appProperties.VALUES.KEY);
    let _iv = CryptoTS.enc.Utf8.parse(this.appProperties.VALUES.IV);
    let encrypted = CryptoTS.AES.encrypt(
      msg, _key, {
        iv: _iv,
        mode: CryptoTS.mode.ECB,
        padding: CryptoTS.pad.PKCS7
      });
    return encrypted.toString();
  }
  
  decryptUsingAES256(msg:any) {
    let _key = CryptoTS.enc.Utf8.parse(this.appProperties.VALUES.KEY);
    let _iv = CryptoTS.enc.Utf8.parse(this.appProperties.VALUES.IV);

    return CryptoTS.AES.decrypt(
      msg, _key, {
        iv: _iv,
        mode: CryptoTS.mode.ECB,
        padding: CryptoTS.pad.PKCS7
      }).toString(CryptoTS.enc.Utf8);
  }

}
